/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CountryService } from './country.service';
import { AllCountriesFailed, AllCountriesLoaded, CountriesActionTypes } from './country.actions';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppState } from '../../app.reducer';

@Injectable()
export class CountryEffects {
  constructor(private actions$: Actions, private store: Store<AppState>, private countryService: CountryService) {}

  loadCities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountriesActionTypes.AllCountriesRequested),
      mergeMap(() =>
        this.countryService.findAllCountries().pipe(
          catchError(err => {
            this.store.dispatch(AllCountriesFailed());
            return of([]);
          }),
        ),
      ),
      map(countries => AllCountriesLoaded({ countries })),
    ),
  );
}
